import { Platform, TextStyle } from 'react-native';
import { ComponentConfig } from '../../ComponentConfig';

export const fontWeightMap = {
  //'100': 'Hairline',
  '200': 'UltraThin',
  '300': 'Light',
  '400': 'Book',
  'normal': 'Book',
  '500': 'Regular',
  '600': 'DemiBold',
  '700': 'Bold',
  'bold': 'Bold',
  '800': 'ExtraBold',
  '900': 'Black',
} as const;

export type FontWeight = keyof typeof fontWeightMap;

export function getFontWeightNameSuffix(weight: TextStyle['fontWeight']) {
  // TODO: newer react native versions have more possible options for fontWeight, so this map might need to be extended.
  // For now we are falling back to font weight 500
  return fontWeightMap[weight as FontWeight] ?? fontWeightMap['500'];
}

export function mapFontWeights(style: TextStyle): TextStyle {
  if (Platform.OS == 'web' || !style.fontWeight) return style;

  const fontWeight = style.fontWeight;
  const fontWeightString = fontWeight.toString() as Exclude<
    TextStyle['fontWeight'],
    number
  >;
  if (!ComponentConfig.enableFontFamilyMapping) {
    return {
      ...style,
      fontWeight: fontWeightString,
    };
  }

  const weightModifier = getFontWeightNameSuffix(style.fontWeight);
  return {
    ...style,
    fontFamily: style.fontFamily + '-' + weightModifier,
    fontWeight: undefined,
  };
}
